<div class="drawer-backdrop" (click)="close.emit()"></div>

<div class="drawer" role="dialog" aria-modal="true" aria-label="New Project">
  <header class="drawer-header">
    <button type="button" class="drawer-close" (click)="close.emit()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
    <span class="header-icon"><mat-icon>add</mat-icon></span>
    <div>
      <div class="header-eyebrow">Create</div>
      <div class="header-title">New Project</div>
    </div>
  </header>

  <div class="drawer-body">
    <p class="drawer-intro">
      Provide identifying details to register a new project. All fields are required.
    </p>

    <section class="field-group">
      <div class="group-label">Organization</div>

      <label class="field">
        <span class="field-label">Organization ID <span class="req">*</span></span>
        <input
          #orgIdInput
          type="text"
          class="field-input mono"
          placeholder="e.g. 5e4910cf-f421-4a89-a11e-94bcf420c4eb"
          [value]="orgId()"
          [class.invalid]="showError(orgId())"
          (input)="orgId.set(orgIdInput.value)"
        />
        @if (showError(orgId())) {
          <span class="field-error">This field is required</span>
        }
      </label>

      <label class="field">
        <span class="field-label">Organization Name <span class="req">*</span></span>
        <input
          #orgNameInput
          type="text"
          class="field-input"
          placeholder="Acme Corporation"
          [value]="orgName()"
          [class.invalid]="showError(orgName())"
          (input)="orgName.set(orgNameInput.value)"
        />
        @if (showError(orgName())) {
          <span class="field-error">This field is required</span>
        }
      </label>
    </section>

    <section class="field-group">
      <div class="group-label">Project</div>

      <label class="field">
        <span class="field-label">Atlas Project ID <span class="req">*</span></span>
        <input
          #atlasIdInput
          type="text"
          class="field-input mono"
          placeholder="ATL-12345"
          [value]="atlasId()"
          [class.invalid]="showError(atlasId())"
          (input)="atlasId.set(atlasIdInput.value)"
        />
        @if (showError(atlasId())) {
          <span class="field-error">This field is required</span>
        }
      </label>

      <label class="field">
        <span class="field-label">Project Name <span class="req">*</span></span>
        <input
          #projectNameInput
          type="text"
          class="field-input"
          placeholder="e.g. Marketing Site Redesign"
          [value]="projectName()"
          [class.invalid]="showError(projectName())"
          (input)="projectName.set(projectNameInput.value)"
        />
        @if (showError(projectName())) {
          <span class="field-error">This field is required</span>
        }
      </label>
    </section>
  </div>

  <footer class="drawer-footer">
    <button type="button" class="btn-cancel" (click)="close.emit()">Cancel</button>
    <button type="button" class="btn-create" [disabled]="busy()" (click)="submit()">
      <mat-icon>add</mat-icon>
      Create Project
    </button>
  </footer>
</div>
